import React, { useEffect, useState } from 'react';
// import PaymentServices from '../services/PaymentServices'; // Adjust path as needed
import PaymentServices from '../../services/externalServices/TicketServices/paymentServices';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CompanyDetailServices from '../../services/externalServices/companyServices';
// import { formatToIST } from "../utils/dateFormater";
import * as XLSX from "xlsx";
// import  UploadBankStatement from '../../Payment/UploadBankStatement'
import UploadTicketStatement from '../../Payment/UploadTicketStatement';
import moment from 'moment';



// const ConsolidatedReport = () => {
//     const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [filteredData, setFilteredData] = useState([]);
//     const [filters, setFilters] = useState({
//         paymentMode: 'all',
//         transactionStatus: 'all',
//         dateRange: 'all',
//         startDate: '',
//         endDate: ''
//     });

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
//     const isTicketAdmin = role === 'ticket-admin';
//     const theatreName1 = accessList?.[0];



//     // For the Pagination

//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 100;

//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//     const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);





//     // Get unique payment modes from data
//     const getPaymentModes = (data) => {
//         const modes = new Set();
//         data.forEach(item => {
//             if (item.paymentMode) {
//                 modes.add(item.paymentMode);
//             }
//         });
//         return Array.from(modes).map(mode => ({
//             value: mode,
//             label: mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase()
//         }));
//     };

//     // Get unique statuses from data
//     const getStatusOptions = (data) => {
//         const statuses = new Set();
//         data.forEach(item => {
//             if (item.transactionStatus) {
//                 statuses.add(item.transactionStatus);
//             }
//         });
//         return Array.from(statuses).map(status => ({
//             value: status,
//             label: status
//         }));
//     };

//     const [paymentModes, setPaymentModes] = useState([
//         { value: 'all', label: 'All Payment Modes' }
//     ]);

//     const [statusOptions, setStatusOptions] = useState([
//         { value: 'all', label: 'All Statuses' }
//     ]);

//     // Apply filters
//     const applyFilters = () => {
//         let result = [...data];

//         // Payment mode filter
//         if (filters.paymentMode !== 'all') {
//             result = result.filter(item => item.paymentMode === filters.paymentMode);
//         }

//         // Status filter
//         if (filters.transactionStatus !== 'all') {
//             result = result.filter(item => item.transactionStatus === filters.transactionStatus);
//         }

//         // Date range filter
//         if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
//             result = result.filter(item => {
//                 const bookingDate = new Date(item.bookingDate);
//                 const startDate = new Date(filters.startDate);
//                 startDate.setHours(0, 0, 0, 0); // Start of the day (00:00:00.000)
//                 const endDate = new Date(filters.endDate);
//                 endDate.setHours(23, 59, 59, 999); // End of the day (23:59:59.999)
//                 return bookingDate >= startDate && bookingDate <= endDate;
//             });
//         } else if (filters.dateRange !== 'all') {
//             const now = new Date();
//             let startDate = new Date();

//             switch (filters.dateRange) {
//                 case 'today':
//                     startDate.setHours(0, 0, 0, 0);
//                     break;
//                 case 'week':
//                     startDate.setDate(now.getDate() - 7);
//                     break;
//                 case 'month':
//                     startDate.setMonth(now.getMonth() - 1);
//                     break;
//                 default:
//                     break;
//             }

//             result = result.filter(item => {
//                 const bookingDate = new Date(item.bookingDate);
//                 return bookingDate >= startDate;
//             });
//         }

//         setFilteredData(result);
//     };

//     useEffect(() => {
//         console.log('in the file of the Revenue reports');
//         const fetchRevenueReport = async () => {
//             try {
//                 const theatreName = theatreName1;
//                 const response = await PaymentServices.getRevenueReportWithSplit(theatreName);
//                 console.log('response in the fetchRevenue report', response.data);
//                 const result = response;
//                 setData(result.data || []);
//                 setFilteredData(result.data || []);

//                 // Update payment modes and status options from data
//                 const modesFromData = getPaymentModes(result.data || []);
//                 setPaymentModes([
//                     { value: 'all', label: 'All Payment Modes' },
//                     ...modesFromData
//                 ]);

//                 const statusesFromData = getStatusOptions(result.data || []);
//                 setStatusOptions([
//                     { value: 'all', label: 'All Statuses' },
//                     ...statusesFromData
//                 ]);
//             } catch (err) {
//                 setError('Failed to load revenue report');
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchRevenueReport();
//     }, []);

//     // Apply filters when filters change
//     useEffect(() => {
//         applyFilters();
//     }, [filters, data]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     if (isLoading) return <div className="text-center py-8">Loading report...</div>;
//     if (error) return <div className="text-center py-8 text-red-500">{error}</div>;

//     const totals = filteredData.reduce((acc, item) => ({
//         totalAmount: acc.totalAmount + item.totalAmount,
//         theatrePayable: acc.theatrePayable + item.theatrePayable,
//         platformEarnings: acc.platformEarnings + item.platformEarnings,
//         count: acc.count + 1
//     }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });






//     return (
//         <div className="container mx-auto px-4 py-6">

//             {/* Main Card */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6">
//                 {/* Filters Section */}



//                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 w-full">
//                     <div className="flex justify-between items-center mb-4">
//                         <h3 className="text-sm font-medium text-gray-700">Filters</h3>
//                         <button
//                             onClick={() => {
//                                 setFilters({
//                                     paymentMode: 'all',
//                                     transactionStatus: 'all',
//                                     dateRange: 'all',
//                                     startDate: '',
//                                     endDate: ''
//                                 });
//                             }}
//                             className="text-xs text-red-600 hover:text-red-800"
//                         >
//                             Clear Filters
//                         </button>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         {/* Date Range Selector */}
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
//                             <select
//                                 name="dateRange"
//                                 value={filters.dateRange}
//                                 onChange={handleFilterChange}
//                                 className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             >
//                                 <option value="all">All Time</option>
//                                 <option value="today">Today</option>
//                                 <option value="week">Last 7 Days</option>
//                                 <option value="month">Last 30 Days</option>
//                                 <option value="custom">Custom Range</option>
//                             </select>

//                             {filters.dateRange === 'custom' && (
//                                 <div className="grid grid-cols-2 gap-3 mt-2">
//                                     <div>
//                                         <label className="block text-xs text-gray-500 mb-1">Start Date</label>
//                                         <input
//                                             type="date"
//                                             name="startDate"
//                                             value={filters.startDate}
//                                             onChange={handleFilterChange}
//                                             className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         />
//                                     </div>
//                                     <div>
//                                         <label className="block text-xs text-gray-500 mb-1">End Date</label>
//                                         <input
//                                             type="date"
//                                             name="endDate"
//                                             value={filters.endDate}
//                                             onChange={handleFilterChange}
//                                             className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         />
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         {/* Payment Mode */}
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Payment Mode</label>
//                             <select
//                                 name="paymentMode"
//                                 value={filters.paymentMode}
//                                 onChange={handleFilterChange}
//                                 className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             >
//                                 {paymentModes.map(mode => (
//                                     <option key={mode.value} value={mode.value}>{mode.label}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Status */}
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//                             <select
//                                 name="transactionStatus"
//                                 value={filters.transactionStatus}
//                                 onChange={handleFilterChange}
//                                 className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             >
//                                 {statusOptions.map(status => (
//                                     <option key={status.value} value={status.value}>{status.label}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                 </div>


//                 {/* Summary Cards */}
//                 <div className="p-6 bg-gray-50">
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Total Bookings</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">{totals.count}</p>
//                         </div>
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Total Revenue</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">₹{totals.totalAmount.toFixed(2)}</p>
//                         </div>
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Theatre Payable</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">₹{totals.theatrePayable.toFixed(2)}</p>
//                         </div>
//                         {!isTicketAdmin &&

//                             <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                                 <h3 className="text-gray-500 text-sm font-medium">Platform Earnings</h3>
//                                 <p className="text-2xl font-bold text-gray-800 mt-1">₹{totals.platformEarnings.toFixed(2)}</p>
//                             </div>
//                         }

//                     </div>
//                 </div>
//             </div>



//             {/* Data Table */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
//                 <div className="overflow-x-auto">
//                     {/* <div className="max-h-[calc(100vh-400px)] overflow-y-auto"> */}
//                     {/* <div className="overflow-y-auto max-h-[calc(100vh-200px)]"> */}
//                     <div className="overflow-y-auto">

//                         <table className="min-w-full divide-y divide-gray-200">
//                             <thead className="bg-gray-50 sticky top-0">
//                                 <tr>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Booking ID</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Theatre</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Date</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Time</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction ID</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatreBaseAmount</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatreGstAmount</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatrePayable</th>
//                                     {!isTicketAdmin &&
//                                         <>
//                                             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformFee</th>
//                                             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformGst</th>
//                                             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">gatewayCharges</th>
//                                             <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformEarnings</th>
//                                         </>
//                                     }
//                                 </tr>
//                             </thead>
//                             <tbody className="bg-white divide-y divide-gray-200">
//                                 {/* {filteredData.map((booking) => ( */}
//                                 {paginatedData.map((booking) => (

//                                     <tr key={booking._id} className="hover:bg-gray-50">
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                                             {booking.bookingId}
//                                         </td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">{booking.movieName}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">{booking.theatreName}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{booking.showDate}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{booking.showTime}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">{booking.transactionId}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap">
//                                             <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                             ${booking.transactionStatus === 'Success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                                                 {booking.transactionStatus}
//                                             </span>
//                                         </td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.totalAmount}</td>

//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.theatreBaseAmount}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.theatreGstAmount}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.theatrePayable}</td>
//                                         {!isTicketAdmin &&
//                                             <>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.platformFee}</td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.platformGst}</td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.gatewayCharges}</td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.platformEarnings}</td>
//                                             </>
//                                         }

//                                         {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                             <button className="text-blue-600 hover:text-blue-800">View</button>
//                                         </td> */}
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>

//             <div className="flex justify-between items-center p-4">
//                 <button
//                     className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//                     onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                     disabled={currentPage === 1}
//                 >
//                     Prev
//                 </button>

//                 <span className="text-sm text-gray-700">
//                     Page {currentPage} of {totalPages}
//                 </span>

//                 <button
//                     className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//                     onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                     disabled={currentPage === totalPages}
//                 >
//                     Next
//                 </button>
//             </div>


//             {/* Print Button */}
//             <div className="mt-6 flex justify-end">
//                 <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
//                     Print Report
//                 </button>
//             </div>
//         </div>
//     );
// };


















const ConsolidatedReport = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    paymentMode: 'all',
    // transactionStatus: 'all',
    transactionStatus: 'COMPLETED',   // 👈 default to COMPLETED
    dateRange: 'today',
    startDate: '',
    endDate: '',
    theatreName: 'all' // <-- New
  });

  const { role = '', accessList = [] } = JSON.parse(localStorage.getItem('admin'));
  const isTicketAdmin = role === 'ticket-admin';
  const theatreName = accessList?.[0];

  const [paymentModes, setPaymentModes] = useState([{ value: 'all', label: 'All Payment Modes' }]);
  const [statusOptions, setStatusOptions] = useState([{ value: 'all', label: 'All Statuses' }]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 500;
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const [theatreOptions, setTheatreOptions] = useState([
    { value: 'all', label: 'All Theatres' }
  ]);
  const [originalData, setOriginalData] = useState([]);



  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);



  const generateReport = () => {
    const headers = [
      "Booking ID", "Movie", "Theatre", "Show Date", "Show Time",
      "Transaction ID", "Status", "Amount", "Theatre Base", "Theatre GST",
      "Theatre Earnings", ...(!isTicketAdmin ? [
        "Platform Fee", "Platform GST", "Gateway Charges", "Platform Earnings"
      ] : [])
    ].join(',');

    const csvRows = filteredData.map(item => {
      const row = [
        item.bookingId,
        `"${item.movieName}"`, // Escape quotes if needed
        `"${item.theatreName}"`,
        formatDateToDDMMYYYY(item.showDate),
        item.showTime,
        item.transactionId,
        item.transactionStatus,
        item.totalAmount,
        item.theatreBaseAmount,
        item.theatreGstAmount,
        item.theatrePayable,
        ...(!isTicketAdmin ? [
          item.platformFee,
          item.platformGst,
          item.gatewayCharges,
          // item.platformEarnings
          item.platformFee // Changed from item.platformEarnings to item.platformFee
        ] : [])
      ];
      return row.join(',');
    });

    const csvContent = [headers, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Revenue_Report_${moment().format('YYYY-MM-DD')}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };


  const getTheatreOptions = (data) => {
    const names = new Set();
    data.forEach(item => {
      if (item.theatreName) {
        names.add(item.theatreName);
      }
    });
    return Array.from(names).map(name => ({
      value: name,
      label: name
    }));
  };


  // useEffect(() => {
  //   const fetchRevenueReport = async () => {
  //     try {
  //       const response = await PaymentServices.getRevenueReportWithSplit(theatreName);
  //       console.log('the response of the revenu report', response);


  //       const items = response.data || [];
  //       const theatresFromData = getTheatreOptions(response.data || []);
  //       setData(items);
  //       setOriginalData(items);
  //       // setFilteredData(items);
  //       setFilteredData(items.filter(i =>
  //         moment(i.showDate, "YYYY/MM/DD").isSame(moment(), 'day')
  //       ));
  //       setPaymentModes([{ value: 'all', label: 'All Payment Modes' }, ...getOptions(items, 'paymentMode')]);

  //       setStatusOptions([{ value: 'all', label: 'All Statuses' }, ...getOptions(items, 'transactionStatus')]);


  //       setTheatreOptions([
  //         { value: 'all', label: 'All Theatres' },
  //         ...theatresFromData
  //       ]);
  //     } catch (err) {
  //       setError('Failed to load revenue report');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  //   fetchRevenueReport();
  // }, []);


  useEffect(() => {
    const fetchRevenueReport = async () => {
      try {
        const response = await PaymentServices.getRevenueReportWithSplit(theatreName);
        console.log('the response of the revenue report', response);

        const rawItems = response.data || [];

        // 🔄 Normalize transactionStatus: SUCCESS ➜ COMPLETED
        // const items = rawItems.map(item => ({
        //   ...item,
        //   transactionStatus: item.transactionStatus?.toUpperCase() === 'SUCCESS' ? 'COMPLETED' : item.transactionStatus
        // }));



        const items = rawItems.map(item => ({
          ...item,
          transactionStatus: item.transactionStatus?.toUpperCase() === 'SUCCESS'
            ? 'COMPLETED'
            : item.transactionStatus?.toUpperCase() // Normalize ALL statuses to uppercase
        }));


        const theatresFromData = getTheatreOptions(items);
        setData(items);
        setOriginalData(items);

        // setFilteredData(items.filter(i =>
        //   moment(i.showDate, "YYYY/MM/DD").isSame(moment(), 'day')
        // ));

        setPaymentModes([
          { value: 'all', label: 'All Payment Modes' },
          ...getOptions(items, 'paymentMode')
        ]);

        setStatusOptions([
          { value: 'all', label: 'All Statuses' },
          ...getOptions(items, 'transactionStatus')
        ]);

        setTheatreOptions([
          { value: 'all', label: 'All Theatres' },
          ...theatresFromData
        ]);

      } catch (err) {
        setError('Failed to load revenue report');
      } finally {
        setIsLoading(false);
      }
    };

    fetchRevenueReport();
  }, []);





  useEffect(() => {
    applyFilters();
  }, [filters, data]);



  const getOptions = (items, key) => {
    return Array.from(new Set(items.map(item => item[key]))).filter(Boolean).map(val => ({
      value: val,
      label: val
    }));
  };

  const applyFilters = () => {
    let result = [...data];
    if (filters.paymentMode !== 'all') result = result.filter(i => i.paymentMode === filters.paymentMode);
    // if (filters.transactionStatus !== 'all') result = result.filter(i => i.transactionStatus === filters.transactionStatus);



    if (filters.transactionStatus !== 'all') {
      result = result.filter(i =>
        i.transactionStatus?.toUpperCase() === filters.transactionStatus.toUpperCase()
      );
    }



    if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
      const start = moment(filters.startDate).startOf('day');
      const end = moment(filters.endDate).endOf('day');

      result = result.filter(i => {
        const showDate = moment(i.showDate, "YYYY/MM/DD"); // Parse with correct format
        return showDate.isBetween(start, end, undefined, '[]'); // inclusive
      });
    } else if (filters.dateRange !== 'all') {
      const now = moment();
      const start = moment();

      if (filters.dateRange === 'today') {
        start.startOf('day');
      } else if (filters.dateRange === 'yesterday') {
        start.subtract(1, 'day').startOf('day');
      } else if (filters.dateRange === 'week') {
        start.subtract(7, 'days').startOf('day');
      } else if (filters.dateRange === 'month') {
        start.subtract(1, 'month').startOf('day');
      }

      result = result.filter(i => {
        const showDate = moment(i.showDate, "YYYY/MM/DD"); // Parse with correct format
        if (filters.dateRange === 'today') {
          return showDate.isSame(moment(), 'day'); // Only today, no future dates
        } else if (filters.dateRange === 'yesterday') {
          return showDate.isSame(start, 'day'); // Only yesterday
        } else {
          return showDate.isSameOrAfter(start, 'day'); // Week/month: from X days ago onward
        }
      });
    }


    if (filters.theatreName !== 'all') {
      result = result.filter(item => item.theatreName === filters.theatreName);
    }

    setFilteredData(result);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  //   const resetFilters = () => {
  //     setFilters({
  //       paymentMode: 'all',
  //       transactionStatus: 'all',
  //       dateRange: 'all',
  //       startDate: '',
  //       endDate: ''
  //     });
  //   };


  const resetFilters = () => {
    setFilters({
      paymentMode: 'all',
      // transactionStatus: 'all',
      transactionStatus: 'COMPLETED',  // 👈 reset back to COMPLETED
      dateRange: 'all',
      startDate: '',
      endDate: '',
      theatreName: 'all'
    });
    // setShowMatchedOnly(false);
    // setMatchedTransactions([]);
    setData(originalData); // <- Reset the data back to original
  };


  const totals = filteredData.reduce((acc, item) => ({
    totalAmount: acc.totalAmount + item.totalAmount,
    theatrePayable: acc.theatrePayable + item.theatrePayable,
    theatreBaseAmount: acc.theatreBaseAmount + item.theatreBaseAmount,
   theatreGstAmount: acc.theatreGstAmount + item.theatreGstAmount,


    // platformEarnings: acc.platformEarnings + item.platformEarnings,
    platformEarnings: acc.platformEarnings + item.platformFee,
    count: acc.count + 1
  }), { totalAmount: 0, theatrePayable:0, theatreBaseAmount: 0,theatreGstAmount:0, platformEarnings: 0, count: 0 });





  if (isLoading) return <div className="text-center py-8">Loading report...</div>;
  if (error) return <div className="text-center py-8 text-red-500">{error}</div>;


  const formatDateToDDMMYYYY = (dateInput) => {
    if (!dateInput) return '';

    // Handle both string dates and Date objects
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date.getTime())) return 'Invalid date';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };





  const handleDelete = async (bookingId) => {
    const confirm = window.confirm("Are you sure you want to permanently delete this booking?");
    if (!confirm) return;

    try {
      await PaymentServices.deleteBookingPermanently(bookingId);
      setData(prev => prev.filter(item => item._id !== bookingId));
      setFilteredData(prev => prev.filter(item => item._id !== bookingId));
    } catch (err) {
      console.error(err);
      alert("Failed to delete booking");
    }
  };



  return (
    <div className="container mx-auto px-6 py-8 space-y-8">
      <div className="bg-white p-6 rounded-xl shadow border border-gray-200 space-y-6">
        {/* 
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">Filters</h2>
          <button onClick={resetFilters} className="text-sm text-red-600 hover:text-red-800">Clear Filters</button>
          <button
              onClick={generateReport}
              className="px-3 py-1 text-sm text-green-600 hover:text-green-800 border border-green-200 rounded hover:bg-green-50 flex items-center gap-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Export CSV
            </button>
        
        </div> */}


        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">Filters</h2>
          <div className="flex gap-2">
            <button
              onClick={resetFilters}
              className="px-3 py-1 text-sm text-red-600 hover:text-red-800 border border-red-200 rounded hover:bg-red-50"
            >
              Clear Filters
            </button>
            <button
              onClick={generateReport}
              className="px-3 py-1 text-sm text-green-600 hover:text-green-800 border border-green-200 rounded hover:bg-green-50 flex items-center gap-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Export Excel
            </button>
            <button
              onClick={async () => {
                const cashIds = filteredData
                  .filter(item => selectedIds.includes(item._id) && item.paymentMethod === 'Cash')
                  .map(item => item._id);

                if (cashIds.length === 0) {
                  alert("No CASH entries selected to delete.");
                  return;
                }

                // const confirm = window.confirm(`Delete ${cashIds.length} CASH entries?`);
                const confirm = window.confirm(`Delete entries?`);
                if (!confirm) return;

                for (let id of cashIds) {
                  await PaymentServices.deleteBookingPermanently(id); // or batch API if available
                }

                setData(prev => prev.filter(item => !cashIds.includes(item._id)));
                setFilteredData(prev => prev.filter(item => !cashIds.includes(item._id)));
                setSelectedIds([]);
                setSelectAll(false);
              }}
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              Delete
            </button>

          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Theatre</label>
            <select
              name="theatreName"
              value={filters.theatreName}
              onChange={handleChange}
              className="mt-1 p-2 border border-gray-300 rounded w-full"
            >
              {theatreOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Payment Mode</label>
            <select name="paymentMode" value={filters.paymentMode} onChange={handleChange} className="mt-1 p-2 border border-gray-300 rounded w-full">
              {paymentModes.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Status</label>
            <select name="transactionStatus" value={filters.transactionStatus} onChange={handleChange} className="mt-1 p-2 border border-gray-300 rounded w-full">
              {statusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Date Range</label>
            <select name="dateRange" value={filters.dateRange} onChange={handleChange} className="mt-1 p-2 border border-gray-300 rounded w-full">
              <option value="today">Today</option> {/* First option */}

              <option value="yesterday">Yesterday</option>
              {/* <option value="today">Today</option> */}
              <option value="week">Last 7 Days</option>
              <option value="month">Last 30 Days</option>
              <option value="custom">Custom</option>
              <option value="all">All Time</option>
            </select>
          </div>
          {filters.dateRange === 'custom' && (
            <div className="grid grid-cols-2 gap-2">
              <input type="date" name="startDate" value={filters.startDate} onChange={handleChange} className="p-2 border rounded" />
              <input type="date" name="endDate" value={filters.endDate} onChange={handleChange} className="p-2 border rounded" />
            </div>
          )}
        </div>

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-gray-100 p-4 rounded shadow">
            <p className="text-sm text-gray-600">Total Bookings</p>
            <p className="text-xl font-bold">{totals.count}</p>
          </div>
          <div className="bg-gray-100 p-4 rounded shadow">
            <p className="text-sm text-gray-600">Total Revenue</p>
            <p className="text-xl font-bold">₹{totals.totalAmount.toFixed(2)}</p>
          </div>
          <div className="bg-gray-100 p-4 rounded shadow">
            <p className="text-sm text-gray-600">Theatre Payable</p>
            <p className="text-xl font-bold">₹{totals.theatrePayable.toFixed(2)}</p>
          </div>
          {!isTicketAdmin && (
            <div className="bg-gray-100 p-4 rounded shadow">
              <p className="text-sm text-gray-600">Platform Earnings</p>
              <p className="text-xl font-bold">₹{totals.platformEarnings.toFixed(2)}</p>
            </div>
          )}
        </div> */}


        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
          {/* Total Bookings Card */}
          <div className="bg-green-50 p-4 rounded-lg shadow-sm border border-green-100">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-full bg-green-100 text-green-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <div>
                <h4 className="text-sm font-medium text-green-800">Total Bookings</h4>
                <p className="text-2xl font-bold text-green-900">{totals.count}</p>
              </div>
            </div>
          </div>

          {/* Total Revenue Card */}
          <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-100">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-full bg-blue-100 text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h4 className="text-sm font-medium text-blue-800">Total Revenue</h4>
                <p className="text-2xl font-bold text-blue-900">₹{totals.totalAmount.toFixed(2)}</p>
              </div>
            </div>
          </div>



          
          {/* Theatre Payable Card */}
          <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-100">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-full bg-yellow-100 text-yellow-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <div>
                <h4 className="text-sm font-medium text-yellow-800">Theatre Earnings(without GST)</h4>
                <p className="text-2xl font-bold text-yellow-900">₹{totals.theatrePayable.toFixed(2)}</p>
              </div>
            </div>
          </div>




   {/* Theatre Base Amount Card */}
          <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-100">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-full bg-yellow-100 text-yellow-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <div>
                <h4 className="text-sm font-medium text-yellow-800">Theatre Earnings( With GST)</h4>
                <p className="text-2xl font-bold text-yellow-900">₹{totals.theatreBaseAmount.toFixed(2)}</p>
              </div>
            </div>
          </div>





          {/* Theatre Payable Card  After TCS*/}
          <div className="bg-orange-50 p-4 rounded-lg shadow-sm border border-orange-100">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-full bg-orange-100 text-orange-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <div>
                <h4 className="text-sm font-medium text-orange-800">Theatre Earnings After 1% TCS</h4>
                {/* <p className="text-2xl font-bold text-orange-900">₹{(totals.theatrePayable * 0.99).toFixed(2)}</p> */}
                <p className="text-2xl font-bold text-orange-900">₹{(totals?.theatreBaseAmount * 0.99).toFixed(2)}</p>
              </div>
            </div>
          </div>


          {/* Cruze Earnings Card */}

          {!isTicketAdmin && (
            <div className="bg-purple-50 p-4 rounded-lg shadow-sm border border-purple-100">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-full bg-purple-100 text-purple-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-purple-800">Cruze Earnings</h4>
                  {/* <p className="text-2xl font-bold text-purple-900">₹{totals.platformEarnings.toFixed(2)}</p> */}
                  <p className="text-2xl font-bold text-purple-900">₹{totals.platformEarnings.toFixed(2)}</p>
                </div>
              </div>
            </div>
          )}
        </div>


        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border border-gray-200">
            <thead className="bg-gray-100">
              {/* <tr> */}

              <tr>
                <th className="px-4 py-2 border">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={e => {
                      const checked = e.target.checked;
                      setSelectAll(checked);
                      setSelectedIds(checked ? paginatedData.map(item => item._id) : []);
                    }}
                  />
                </th>
                {/* other headers */}

                <th className="px-4 py-2 border">Booking ID</th>
                <th className="px-4 py-2 border">Movie</th>
                <th className="px-4 py-2 border">Theatre</th>
                <th className="px-4 py-2 border min-w-[160px]">Show Date</th>
                <th className="px-4 py-2 border min-w-[160px]">Show Time</th>
                <th className="px-4 py-2 border">Transaction ID</th>
                <th className="px-4 py-2 border">Status</th>
                <th className="px-4 py-2 border">Amount</th>
                <th className="px-4 py-2 border">Theatre Base</th>
                <th className="px-4 py-2 border">Theatre GST</th>
                <th className="px-4 py-2 border">Theatre Payable</th>
                {!isTicketAdmin && (
                  <>
                    <th className="px-4 py-2 border">Platform Fee</th>
                    <th className="px-4 py-2 border">Platform GST</th>
                    <th className="px-4 py-2 border">Gateway Charges</th>
                    {/* <th className="px-4 py-2 border">Platform Earnings</th> */}
                  </>
                )}
                <th className="px-4 py-2 border">Convenience Fee</th>
                <th className="px-4 py-2 border">Convenience GST</th>
                {!isTicketAdmin && (
                  <>
                    {/* <th className="px-4 py-2 border">Platform Fee</th>
                    <th className="px-4 py-2 border">Platform GST</th>
                    <th className="px-4 py-2 border">Gateway Charges</th> */}
                    <th className="px-4 py-2 border">Platform Earnings</th>
                  </>
                )}
                {/* <th className="px-4 py-2 border">Actions</th> */}
              </tr>


            </thead>
            <tbody>
              {paginatedData.map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border">
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(item._id)}
                      onChange={() => {
                        setSelectedIds(prev =>
                          prev.includes(item._id)
                            ? prev.filter(id => id !== item._id)
                            : [...prev, item._id]
                        );
                      }}
                    />
                  </td>

                  <td className="px-4 py-2 border">{item.bookingId}</td>
                  <td className="px-4 py-2 border">{item.movieName}</td>
                  <td className="px-4 py-2 border">{item.theatreName}</td>
                  <td className="px-4 py-2 border min-w-[160px]">{formatDateToDDMMYYYY(item.showDate)}</td>
                  <td className="px-4 py-2 border min-w-[160px]">{item.showTime}</td>
                  <td className="px-4 py-2 border font-mono">{item.transactionId}</td>
                  <td className="px-4 py-2 border">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${item.transactionStatus === 'Success' || item.transactionStatus === 'COMPLETED' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {/* {item.transactionStatus} */}
                      {item.transactionStatus?.toLowerCase() === 'success' ? 'COMPLETED' : item.transactionStatus || ''}
                    </span>
                  </td>
                  <td className="px-4 py-2 border">₹{item.totalAmount}</td>
                  {/* <td className="px-4 py-2 border">
                    ₹{item.totalAmount}
                    {(item.paymentMethod === 'Cash' && item.theatreName === 'Shiva Theatre') && (
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="ml-2 text-red-500 hover:text-red-700 text-xs"
                      >
                        Delete
                      </button>
                    )}
                  </td> */}
                  <td className="px-4 py-2 border">₹{item.theatreBaseAmount}</td>
                  <td className="px-4 py-2 border">₹{item.theatreGstAmount}</td>
                  <td className="px-4 py-2 border">₹{item.theatrePayable}</td>
                  {!isTicketAdmin && (
                    <>
                      <td className="px-4 py-2 border">₹{item.platformFee}</td>
                      <td className="px-4 py-2 border">₹{item.platformGst}</td>
                      <td className="px-4 py-2 border">₹{item.gatewayCharges}</td>

                    </>
                  )}

                  <td className="px-4 py-2 border">
                    {item.convenienceFee ? `₹${item.convenienceFee}` : ''}
                  </td>
                  <td className="px-4 py-2 border">
                    {item.convenienceGst ? `₹${item.convenienceGst}` : ''}
                  </td>
                  {!isTicketAdmin && (
                    <>

                      <td className="px-4 py-2 border">₹{item.platformFee}</td>
                    </>
                  )}


                  {/* <td className="px-4 py-2 border">
                    {(item.paymentMethod === 'Cash' && item.theatreName === 'Shiva Theatre') && (
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="text-red-600 hover:text-red-800 text-sm underline"
                      >
                        Delete
                      </button>
                    )}
                  </td> */}


                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center">
          <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">Previous</button>
          <span className="text-sm text-gray-600">Page {currentPage} of {totalPages}</span>
          <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">Next</button>
        </div>

        {/* <div className="mt-6">
          <UploadTicketStatement />
        </div> */}
      </div>
    </div>
  );
};









// export default ConsolidatedReport;






// const ConsolidatedReport = () => {
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [filters, setFilters] = useState({
//         paymentMode: 'all',
//         transactionStatus: 'all',
//         dateRange: 'all',
//         startDate: '',
//         endDate: ''
//     });

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
//     const theatreName = accessList?.[0] || "";
//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 100;
//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//     const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
//     const [paymentModes, setPaymentModes] = useState([{ value: 'all', label: 'All Payment Modes' }]);
//     const [statusOptions, setStatusOptions] = useState([{ value: 'all', label: 'All Statuses' }]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const res = await PaymentServices.getRevenueReportWithSplit(theatreName);
//                 const items = res.data || [];
//                 setData(items);
//                 setFilteredData(items);
//                 setPaymentModes([{ value: 'all', label: 'All Payment Modes' }, ...getOptions(items, 'paymentMode')]);
//                 setStatusOptions([{ value: 'all', label: 'All Statuses' }, ...getOptions(items, 'transactionStatus')]);
//             } catch (err) {
//                 setError("Failed to fetch report.");
//             } finally {
//                 setIsLoading(false);
//             }
//         };
//         fetchData();
//     }, []);

//     useEffect(() => {
//         applyFilters();
//     }, [filters, data]);

//     const getOptions = (items, key) => {
//         return Array.from(new Set(items.map(item => item[key]))).filter(Boolean).map(val => ({
//             value: val,
//             label: val
//         }));
//     };

//     const applyFilters = () => {
//         let result = [...data];

//         if (filters.paymentMode !== 'all') result = result.filter(i => i.paymentMode === filters.paymentMode);
//         if (filters.transactionStatus !== 'all') result = result.filter(i => i.transactionStatus === filters.transactionStatus);

//         if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
//             const start = new Date(filters.startDate); start.setHours(0, 0, 0, 0);
//             const end = new Date(filters.endDate); end.setHours(23, 59, 59, 999);
//             result = result.filter(i => new Date(i.bookingDate) >= start && new Date(i.bookingDate) <= end);
//         } else if (filters.dateRange !== 'all') {
//             const now = new Date();
//             const start = new Date();
//             if (filters.dateRange === 'today') start.setHours(0, 0, 0, 0);
//             else if (filters.dateRange === 'week') start.setDate(now.getDate() - 7);
//             else if (filters.dateRange === 'month') start.setMonth(now.getMonth() - 1);
//             result = result.filter(i => new Date(i.bookingDate) >= start);
//         }

//         setFilteredData(result);
//     };

//     const totals = filteredData.reduce((acc, item) => ({
//         totalAmount: acc.totalAmount + item.totalAmount,
//         theatrePayable: acc.theatrePayable + item.theatrePayable,
//         platformEarnings: acc.platformEarnings + item.platformEarnings,
//         count: acc.count + 1
//     }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//     };

//     const resetFilters = () => {
//         setFilters({
//             paymentMode: 'all',
//             transactionStatus: 'all',
//             dateRange: 'all',
//             startDate: '',
//             endDate: ''
//         });
//     };

//     if (isLoading) return <div className="text-center py-8">Loading...</div>;
//     if (error) return <div className="text-center py-8 text-red-500">{error}</div>;

//     return (
//         <div className="container mx-auto px-4 py-6">
//             <div className="bg-white rounded-xl shadow p-6 border border-gray-100">
//                 {/* Filters */}
//                 <div className="mb-6 space-y-4">
//                     <div className="flex flex-wrap gap-4">
//                         <select name="paymentMode" value={filters.paymentMode} onChange={handleChange} className="p-2 border rounded">
//                             {paymentModes.map(opt => (
//                                 <option key={opt.value} value={opt.value}>{opt.label}</option>
//                             ))}
//                         </select>

//                         <select name="transactionStatus" value={filters.transactionStatus} onChange={handleChange} className="p-2 border rounded">
//                             {statusOptions.map(opt => (
//                                 <option key={opt.value} value={opt.value}>{opt.label}</option>
//                             ))}
//                         </select>

//                         <select name="dateRange" value={filters.dateRange} onChange={handleChange} className="p-2 border rounded">
//                             <option value="all">All Time</option>
//                             <option value="today">Today</option>
//                             <option value="week">Last 7 Days</option>
//                             <option value="month">Last 30 Days</option>
//                             <option value="custom">Custom</option>
//                         </select>

//                         {filters.dateRange === 'custom' && (
//                             <>
//                                 <DatePicker
//                                     selected={filters.startDate}
//                                     onChange={(date) => setFilters(prev => ({ ...prev, startDate: date }))}
//                                     placeholderText="Start Date"
//                                     className="p-2 border rounded"
//                                 />
//                                 <DatePicker
//                                     selected={filters.endDate}
//                                     onChange={(date) => setFilters(prev => ({ ...prev, endDate: date }))}
//                                     placeholderText="End Date"
//                                     className="p-2 border rounded"
//                                 />
//                             </>
//                         )}

//                         <button onClick={resetFilters} className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600">Reset</button>
//                     </div>
//                 </div>

//                 {/* Table */}
//                 <div className="overflow-x-auto">
//                     <table className="min-w-full text-sm text-left border">
//                         <thead className="bg-gray-100">
//                             <tr>
//                                 <th className="px-4 py-2 border">Date</th>
//                                 <th className="px-4 py-2 border">Payment Mode</th>
//                                 <th className="px-4 py-2 border">Status</th>
//                                 <th className="px-4 py-2 border">Total</th>
//                                 <th className="px-4 py-2 border">Theatre</th>
//                                 <th className="px-4 py-2 border">Platform</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {paginatedData.map((item, idx) => (
//                                 <tr key={idx} className="border-t hover:bg-gray-50">
//                                     <td className="px-4 py-2 border">{new Date(item.bookingDate).toLocaleString()}</td>
//                                     <td className="px-4 py-2 border">{item.paymentMode}</td>
//                                     <td className="px-4 py-2 border">{item.transactionStatus}</td>
//                                     <td className="px-4 py-2 border">{item.totalAmount}</td>
//                                     <td className="px-4 py-2 border">{item.theatrePayable}</td>
//                                     <td className="px-4 py-2 border">{item.platformEarnings}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Totals */}
//                 <div className="mt-4 text-sm text-gray-700">
//                     <p>Total Records: <strong>{totals.count}</strong></p>
//                     <p>Total Amount: ₹{totals.totalAmount.toFixed(2)}</p>
//                     <p>Theatre Payable: ₹{totals.theatrePayable.toFixed(2)}</p>
//                     <p>Platform Earnings: ₹{totals.platformEarnings.toFixed(2)}</p>
//                 </div>

//                 {/* Pagination */}
//                 <div className="mt-4 flex items-center justify-between">
//                     <button
//                         className="px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-50"
//                         onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                         disabled={currentPage === 1}
//                     >
//                         Prev
//                     </button>
//                     <span className="text-sm text-gray-600">Page {currentPage} of {totalPages}</span>
//                     <button
//                         className="px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-50"
//                         onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                         disabled={currentPage === totalPages}
//                     >
//                         Next
//                     </button>
//                 </div>

//                 {/* Upload Ticket Statement */}
//                 <div className="mt-6">
//                     <UploadTicketStatement />
//                 </div>
//             </div>
//         </div>
//     );
// };


// const ConsolidatedReport = () => {
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [filters, setFilters] = useState({
//     paymentMode: 'all',
//     transactionStatus: 'all',
//     dateRange: 'all',
//     startDate: '',
//     endDate: ''
//   });

//   const { role = '', accessList = [] } = JSON.parse(localStorage.getItem('admin') || '{}');
//   const isTicketAdmin = role === 'ticket-admin';
//   const theatreName = accessList?.[0] || '';

//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 100;
//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

//   const [paymentModes, setPaymentModes] = useState([{ value: 'all', label: 'All Payment Modes' }]);
//   const [statusOptions, setStatusOptions] = useState([{ value: 'all', label: 'All Statuses' }]);

//     //   useEffect(() => {
//     //     console.log('in the file of the Revenue reports');
//     //     const fetchRevenueReport = async () => {
//     //         try {
//     //             const theatreName = theatreName1;
//     //             const response = await PaymentServices.getRevenueReportWithSplit(theatreName);
//     //             console.log('response in the fetchRevenue report', response.data);
//     //             const result = response;
//     //             setData(result.data || []);
//     //             setFilteredData(result.data || []);

//     //             // Update payment modes and status options from data
//     //             const modesFromData = getPaymentModes(result.data || []);
//     //             setPaymentModes([
//     //                 { value: 'all', label: 'All Payment Modes' },
//     //                 ...modesFromData
//     //             ]);

//     //             const statusesFromData = getStatusOptions(result.data || []);
//     //             setStatusOptions([
//     //                 { value: 'all', label: 'All Statuses' },
//     //                 ...statusesFromData
//     //             ]);
//     //         } catch (err) {
//     //             setError('Failed to load revenue report');
//     //         } finally {
//     //             setIsLoading(false);
//     //         }
//     //     };

//     //     fetchRevenueReport();
//     // }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await PaymentServices.getRevenueReportWithSplit(theatreName);

//         console.log('data in res', res);
//         const items = res || [];
//         setData(items);
//         setFilteredData(items);
//         setPaymentModes([{ value: 'all', label: 'All Payment Modes' }, ...getOptions(items, 'paymentMode')]);
//         setStatusOptions([{ value: 'all', label: 'All Statuses' }, ...getOptions(items, 'transactionStatus')]);
//       } catch (err) {
//         console.error('in consolidated reports',err);
//       }
//     };
//     fetchData();
//   }, []);

//   useEffect(() => {
//     applyFilters();
//   }, [filters, data]);

//   const getOptions = (items, key) => {
//     return Array.from(new Set(items.map(item => item[key]))).filter(Boolean).map(val => ({
//       value: val,
//       label: val
//     }));
//   };

//   const applyFilters = () => {
//     let result = [...data];
//     if (filters.paymentMode !== 'all') result = result.filter(i => i.paymentMode === filters.paymentMode);
//     if (filters.transactionStatus !== 'all') result = result.filter(i => i.transactionStatus === filters.transactionStatus);
//     if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
//       const start = new Date(filters.startDate); start.setHours(0, 0, 0, 0);
//       const end = new Date(filters.endDate); end.setHours(23, 59, 59, 999);
//       result = result.filter(i => new Date(i.bookingDate) >= start && new Date(i.bookingDate) <= end);
//     } else if (filters.dateRange !== 'all') {
//       const now = new Date();
//       const start = new Date();
//       if (filters.dateRange === 'today') start.setHours(0, 0, 0, 0);
//       else if (filters.dateRange === 'week') start.setDate(now.getDate() - 7);
//       else if (filters.dateRange === 'month') start.setMonth(now.getMonth() - 1);
//       result = result.filter(i => new Date(i.bookingDate) >= start);
//     }
//     setFilteredData(result);
//   };

//   const handleChange = e => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//   };

//   const totals = filteredData.reduce((acc, item) => ({
//     totalAmount: acc.totalAmount + item.totalAmount,
//     theatrePayable: acc.theatrePayable + item.theatrePayable,
//     platformEarnings: acc.platformEarnings + item.platformEarnings,
//     count: acc.count + 1
//   }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });

//   const resetFilters = () => {
//     setFilters({
//       paymentMode: 'all',
//       transactionStatus: 'all',
//       dateRange: 'all',
//       startDate: '',
//       endDate: ''
//     });
//   };

//   return (
//     <div className="container mx-auto px-4 py-6">
//       <div className="bg-white p-6 rounded-xl shadow border border-gray-200">







//       {/* Filters */}
//       <div className="mb-6">
//           <div className="flex flex-wrap items-end gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Payment Mode</label>
//               <select name="paymentMode" value={filters.paymentMode} onChange={handleChange} className="p-2 border rounded w-48">
//                 {paymentModes.map(opt => (
//                   <option key={opt.value} value={opt.value}>{opt.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Status</label>
//               <select name="transactionStatus" value={filters.transactionStatus} onChange={handleChange} className="p-2 border rounded w-48">
//                 {statusOptions.map(opt => (
//                   <option key={opt.value} value={opt.value}>{opt.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Date Range</label>
//               <select name="dateRange" value={filters.dateRange} onChange={handleChange} className="p-2 border rounded w-48">
//                 <option value="all">All Time</option>
//                 <option value="today">Today</option>
//                 <option value="week">Last 7 Days</option>
//                 <option value="month">Last 30 Days</option>
//                 <option value="custom">Custom</option>
//               </select>
//             </div>
//             {filters.dateRange === 'custom' && (
//               <>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">Start Date</label>
//                   <input type="date" name="startDate" value={filters.startDate} onChange={handleChange} className="p-2 border rounded" />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">End Date</label>
//                   <input type="date" name="endDate" value={filters.endDate} onChange={handleChange} className="p-2 border rounded" />
//                 </div>
//               </>
//             )}
//             <div>
//               <button onClick={resetFilters} className="mt-5 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">Reset</button>
//             </div>
//           </div>
//         </div>




//         {/* Summary Cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//           <div className="bg-gray-50 p-4 rounded shadow">
//             <h4 className="text-sm text-gray-500">Total Bookings</h4>
//             <p className="text-2xl font-bold text-gray-700">{totals.count}</p>
//           </div>
//           <div className="bg-gray-50 p-4 rounded shadow">
//             <h4 className="text-sm text-gray-500">Total Revenue</h4>
//             <p className="text-2xl font-bold text-gray-700">₹{totals.totalAmount.toFixed(2)}</p>
//           </div>
//           <div className="bg-gray-50 p-4 rounded shadow">
//             <h4 className="text-sm text-gray-500">Theatre Payable</h4>
//             <p className="text-2xl font-bold text-gray-700">₹{totals.theatrePayable.toFixed(2)}</p>
//           </div>
//           {!isTicketAdmin && (
//             <div className="bg-gray-50 p-4 rounded shadow">
//               <h4 className="text-sm text-gray-500">Platform Earnings</h4>
//               <p className="text-2xl font-bold text-gray-700">₹{totals.platformEarnings.toFixed(2)}</p>
//             </div>
//           )}
//         </div>

//         {/* Data Table */}
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-sm text-left border">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="px-4 py-2 border">Booking ID</th>
//                 <th className="px-4 py-2 border">Movie</th>
//                 <th className="px-4 py-2 border">Theatre</th>
//                 <th className="px-4 py-2 border">Show Date</th>
//                 <th className="px-4 py-2 border">Show Time</th>
//                 <th className="px-4 py-2 border">Transaction ID</th>
//                 <th className="px-4 py-2 border">Amount</th>
//                 <th className="px-4 py-2 border">Status</th>
//                 <th className="px-4 py-2 border">theatreBaseAmount</th>
//                 <th className="px-4 py-2 border">theatreGstAmount</th>
//                 <th className="px-4 py-2 border">theatrePayable</th>
//                 {!isTicketAdmin && (
//                   <>
//                     <th className="px-4 py-2 border">platformFee</th>
//                     <th className="px-4 py-2 border">platformGst</th>
//                     <th className="px-4 py-2 border">gatewayCharges</th>
//                     <th className="px-4 py-2 border">platformEarnings</th>
//                   </>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.map((item, idx) => (
//                 <tr key={idx} className="hover:bg-gray-50">
//                   <td className="px-4 py-2 border">{item.bookingId}</td>
//                   <td className="px-4 py-2 border">{item.movieName}</td>
//                   <td className="px-4 py-2 border">{item.theatreName}</td>
//                   <td className="px-4 py-2 border">{item.showDate}</td>
//                   <td className="px-4 py-2 border">{item.showTime}</td>
//                   <td className="px-4 py-2 border font-mono">{item.transactionId}</td>
//                   <td className="px-4 py-2 border">₹{item.totalAmount}</td>
//                   <td className="px-4 py-2 border">
//                     <span className={`px-2 py-1 rounded-full text-xs font-semibold ${item.transactionStatus === 'Success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//                       {item.transactionStatus}
//                     </span>
//                   </td>
//                   <td className="px-4 py-2 border">₹{item.theatreBaseAmount}</td>
//                   <td className="px-4 py-2 border">₹{item.theatreGstAmount}</td>
//                   <td className="px-4 py-2 border">₹{item.theatrePayable}</td>
//                   {!isTicketAdmin && (
//                     <>
//                       <td className="px-4 py-2 border">₹{item.platformFee}</td>
//                       <td className="px-4 py-2 border">₹{item.platformGst}</td>
//                       <td className="px-4 py-2 border">₹{item.gatewayCharges}</td>
//                       <td className="px-4 py-2 border">₹{item.platformEarnings}</td>
//                     </>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-between items-center mt-4">
//           <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">Prev</button>
//           <span className="text-sm text-gray-600">Page {currentPage} of {totalPages}</span>
//           <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">Next</button>
//         </div>
//       </div>
//     </div>
//   );
// };

export default ConsolidatedReport;



